import {
  LOGIN_USER,
  LOGIN_SUCCESS,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  API_ERROR,
  SOCIAL_LOGIN,
  OTP_GENERATE_SUCCESS,
  OTP_VERIFY_SUCCESS,
  OTP_ACTION_ERROR,
  CLEAR_LOGIN_MESSAGE,
} from "./actionTypes"

export const loginUser = (user, history) => {
  return {
    type: LOGIN_USER,
    payload: { user, history },
  }
}

export const loginSuccess = user => {
  return {
    type: LOGIN_SUCCESS,
    payload: user,
  }
}

export const logoutUser = history => {
  return {
    type: LOGOUT_USER,
    payload: { history },
  }
}

export const logoutUserSuccess = () => {
  return {
    type: LOGOUT_USER_SUCCESS,
    payload: {},
  }
}

export const apiError = error => {
  return {
    type: API_ERROR,
    payload: error,
  }
}

export const socialLogin = (data, history, type) => {
  return {
    type: SOCIAL_LOGIN,
    payload: { data, history, type },
  }
}

// OTP Actions
export const otpGenerateSuccess = (message) => ({
  type: OTP_GENERATE_SUCCESS,
  payload: message,
})

export const otpVerifySuccess = (message, userData) => ({
  type: OTP_VERIFY_SUCCESS,
  payload: { message, userData },
})

export const otpActionError = (message) => ({
  type: OTP_ACTION_ERROR,
  payload: message,
})

export const clearLoginMessage = () => ({
  type: CLEAR_LOGIN_MESSAGE,
})